// extracted by mini-css-extract-plugin
export var readonly = "_ip-1";
export var star = "_ip-0";